import { IconInfoSolid, Text } from '@croquiscom-pvt/zds';
import { Tooltip } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

import { numberWithCommas } from '@common/utils';
export const PriceSummaryRow = ({
  label,
  price,
  prefix_price,
  price_color,
  style,
  tooltip_text,
}: {
  label: string;
  price: number;
  prefix_price?: string;
  price_color?: string;
  style?: React.CSSProperties;
  tooltip_text?: string;
}) => {
  return (
    <PriceRow style={style}>
      <Text variant='Body_14_Regular' v3Color='gray900' style={{ display: 'flex', alignItems: 'center' }} as='div'>
        {label}
        {!!tooltip_text && (
          <Tooltip content={tooltip_text} openTrigger='click' placement='top'>
            <WrapperIconInfo>
              <IconInfoSolid v3Color='gray200' width={24} height={24} />
            </WrapperIconInfo>
          </Tooltip>
        )}
      </Text>
      <PriceInfo>
        <Text variant='Body_15_SemiBold' style={{ color: price_color }}>
          {prefix_price}
          {numberWithCommas(price)}원
        </Text>
      </PriceInfo>
    </PriceRow>
  );
};

const PriceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 18px;
`;

const PriceInfo = styled.div`
  display: flex;
  align-items: center;
`;

const WrapperIconInfo = styled.div`
  height: 24px;
`;
